<template>
  <div class="dnt-container glassy-app">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class="dnt-header glassy-card slide-in">
          <v-container fluid class="pa-4">
            <h2 class="dnt-title earthwerk-font">DONATION DETAILS</h2>
            <div class="dnt-title-decoration"></div>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card flat class="dnt-card glassy-card slide-in-delayed">
          <v-container fluid class="dnt-form-grid">
            <!-- Donation Summary Section -->
            <v-flex xs12 class="dnt-section-header">
              <v-icon color="primary" class="section-icon">mdi-heart</v-icon>
              <span class="dnt-section-title">Donation Summary</span>
            </v-flex>

            <v-flex md4 xs12 class="pa-2">
              <v-card flat class="dnt-summary-card glassy-sub-card">
                <v-container>
                  <div class="dnt-summary-item">
                    <v-icon large class="dnt-summary-icon">mdi-charity</v-icon>
                    <div>
                      <p class="dnt-summary-label">CAUSE</p>
                      <p class="dnt-summary-value">
                        {{ getDonation.payment_options }}
                        <v-btn v-if="getDonation.source === 'Booking'"
                               small
                               text
                               :to="{ name: 'BookingDetails', params: { id: getDonation.booking_id } }"
                               class="dnt-booking-link glassy-link">
                          View Booking
                        </v-btn>
                      </p>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex md4 xs12 class="pa-2">
              <v-card flat class="dnt-summary-card glassy-sub-card">
                <v-container>
                  <div class="dnt-summary-item">
                    <v-icon large class="dnt-summary-icon">mdi-cash</v-icon>
                    <div>
                      <p class="dnt-summary-label">AMOUNT</p>
                      <p class="dnt-summary-value">{{ getDonation.currency }} {{ getDonation.amount }}</p>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex md4 xs12 class="pa-2">
              <v-card flat class="dnt-summary-card glassy-sub-card">
                <v-container>
                  <div class="dnt-summary-item">
                    <v-icon large class="dnt-summary-icon">mdi-calendar</v-icon>
                    <div>
                      <p class="dnt-summary-label">DATE</p>
                      <p class="dnt-summary-value">{{ formated_date_time(getDonation.created_at) }}</p>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-flex>

            <!-- Status Section -->
            <v-flex xs12 class="pa-2">
              <v-card flat :color="getStatusColor" class="glassy-status-card">
                <v-container>
                  <div class="dnt-status-item">
                    <v-icon large class="dnt-status-icon">mdi-information</v-icon>
                    <div>
                      <p class="dnt-status-label">STATUS</p>
                      <p class="dnt-status-value">{{ getDonation.payment_status }}</p>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-flex>

            <!-- Payment Method Section -->
            <v-flex xs12 class="pa-2">
              <v-card flat class="glassy-sub-card">
                <v-container>
                  <div class="dnt-status-item">
                    <v-icon large class="dnt-status-icon">mdi-credit-card</v-icon>
                    <div>
                      <p class="dnt-status-label">PAYMENT METHOD</p>
                      <p class="dnt-status-value">{{ getDonation.payment_method || 'Not specified' }}</p>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-flex>

            <!-- Donor Information Section -->
            <v-flex xs12 class="dnt-section-header">
              <v-icon color="primary" class="section-icon">mdi-account-circle</v-icon>
              <span class="dnt-section-title">Donor Information</span>
            </v-flex>

            <v-flex md6 xs12 class="pa-2">
              <v-text-field :value="getDonation.first_name"
                            label="First Name"
                            readonly
                            outlined
                            dense
                            class="glassy-input dnt-modern-input"
                            prepend-inner-icon="mdi-account"></v-text-field>
            </v-flex>

            <v-flex md6 xs12 class="pa-2">
              <v-text-field :value="getDonation.sur_name"
                            label="Last Name"
                            readonly
                            outlined
                            dense
                            class="glassy-input dnt-modern-input"
                            prepend-inner-icon="mdi-account"></v-text-field>
            </v-flex>

            <v-flex md6 xs12 class="pa-2">
              <v-text-field :value="getDonation.email"
                            label="Email"
                            readonly
                            outlined
                            dense
                            class="glassy-input dnt-modern-input"
                            prepend-inner-icon="mdi-email"></v-text-field>
            </v-flex>

            <v-flex md6 xs12 class="pa-2">
              <v-text-field :value="getDonation.phone_number"
                            label="Phone Number"
                            readonly
                            outlined
                            dense
                            class="glassy-input dnt-modern-input"
                            prepend-inner-icon="mdi-phone"></v-text-field>
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-text-field :value="getDonation.country"
                            label="Country"
                            readonly
                            outlined
                            dense
                            class="glassy-input dnt-modern-input"
                            prepend-inner-icon="mdi-earth"></v-text-field>
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-textarea :value="getDonation.additional_note"
                          label="Additional Note"
                          readonly
                          outlined
                          dense
                          class="glassy-input dnt-modern-input"
                          rows="2"
                          prepend-inner-icon="mdi-note-text"></v-textarea>
            </v-flex>

            <!-- Actions Section -->
            <v-flex xs12 class="pa-2 dnt-actions">
              <v-btn color="error"
                     depressed
                     @click="canceling = true"
                     v-if="!canceling && getDonation.payment_status === 'Pending Payment'"
                     class="dnt-action-btn glassy-btn-error">
                <v-icon left>mdi-cancel</v-icon>
                Cancel Donation
              </v-btn>

              <v-btn color="error"
                     depressed
                     @click="cancelDonation()"
                     v-if="canceling"
                     class="dnt-action-btn glassy-btn-error">
                <v-icon left>mdi-alert-circle</v-icon>
                Confirm Cancellation
              </v-btn>

              <v-btn color="secondary"
                     depressed
                     @click="canceling = false"
                     v-if="canceling"
                     class="dnt-action-btn glassy-btn-secondary">
                <v-icon left>mdi-arrow-left</v-icon>
                Go Back
              </v-btn>
            </v-flex>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import DonationVuex from '../../../mixins/Computed/DonationVuex'
  import DateMixin from '../../../mixins/Functions/DateMixins'

  export default {
    data() {
      return {
        canceling: false
      }
    },
    created() {
      this.$store.dispatch('get_donation', this.$route.params.donation_id)
    },
    methods: {
      cancelDonation: function () {
        this.$store.dispatch('delete_donation', this.$route.params.donation_id)
      }
    },
    computed: {
      getStatusColor() {
        switch (this.getDonation.payment_status) {
          case 'Paid':
            return 'success'
          case 'Pending Payment':
            return 'warning'
          case 'Cancelled':
            return 'error'
          default:
            return 'grey'
        }
      }
    },
    mixins: [DonationVuex, DateMixin]
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  /* --- Global Layout --- */
  .glassy-app {
    min-height: 100vh;
    background: #f0f2f5;
  }

  .dnt-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: radial-gradient(ellipse at 50% 50%, rgba(116, 165, 51, 0.08) 0%, rgba(240, 242, 245, 0.90) 100%), url('https://www.olpejetaconservancy.org/wp-content/uploads/2024/07/Cape-Buffalo-1-scaled.webp') no-repeat center center fixed;
    background-size: cover;
    min-height: 100vh;
  }

  /* --- Slide-in Animations --- */
  .slide-in {
    animation: slideUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    opacity: 0;
    transform: translateY(40px);
  }

  .slide-in-delayed {
    animation: slideUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.15s forwards;
    opacity: 0;
    transform: translateY(30px);
  }

  @keyframes slideUp {
    0% {
      opacity: 0;
      transform: translateY(40px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* --- Glassy Cards - More Transparent --- */
  .glassy-card {
    background: rgba(255, 255, 255, 0.08) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
    transition: all 0.4s ease;
    position: relative;
    z-index: 10;
  }

    .glassy-card:hover {
      background: rgba(255, 255, 255, 0.15) !important;
      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.10);
    }

  .glassy-sub-card {
    background: rgba(255, 255, 255, 0.06) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    height: 100%;
  }

    .glassy-sub-card:hover {
      background: rgba(255, 255, 255, 0.12) !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }

  /* --- Header --- */
  .dnt-header {
    border-radius: 20px !important;
    margin-bottom: 20px;
    background: rgba(116, 165, 51, 0.20) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
    padding: 8px 0;
  }

  .dnt-title {
    color: #1e2a3a;
    font-size: 28px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 8px;
    text-shadow: 0 2px 4px rgba(255, 255, 255, 0.2);
  }

  .dnt-title-decoration {
    width: 80px;
    height: 4px;
    background: rgba(116, 165, 51, 0.6);
    border-radius: 2px;
    margin: 0 auto 8px;
    box-shadow: 0 2px 8px rgba(116, 165, 51, 0.1);
  }

  /* --- Card --- */
  .dnt-card {
    border-radius: 20px !important;
    transition: all 0.3s ease;
    overflow: hidden;
    padding: 24px;
    background: rgba(255, 255, 255, 0.06) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  }

  .dnt-form-grid {
    display: flex;
    flex-wrap: wrap;
    margin: -8px;
  }

  /* --- Section Headers --- */
  .dnt-section-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 8px 12px;
    margin-bottom: 8px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.15);
  }

  .section-icon {
    color: #74a533 !important;
    font-size: 28px;
    filter: drop-shadow(0 2px 4px rgba(116, 165, 51, 0.1));
  }

  .dnt-section-title {
    font-weight: 600;
    color: #1e2a3a;
    font-size: 18px;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
  }

  /* --- Glassy Inputs - More Transparent --- */
  .glassy-input .v-input__slot {
    background: rgba(255, 255, 255, 0.10) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    transition: all 0.3s ease;
  }

    .glassy-input .v-input__slot:hover {
      background: rgba(255, 255, 255, 0.20) !important;
      border-color: rgba(255, 255, 255, 0.30);
    }

    .glassy-input .v-input__slot:focus-within {
      background: rgba(255, 255, 255, 0.30) !important;
      border-color: #74a533;
      box-shadow: 0 0 0 3px rgba(116, 165, 51, 0.08);
    }

  .glassy-input .v-label {
    color: #2d3748 !important;
    font-weight: 500;
    font-size: 15px;
  }

  .glassy-input input,
  .glassy-input textarea {
    color: #1e2a3a !important;
    font-size: 16px;
    caret-color: #74a533;
  }

    .glassy-input input::placeholder,
    .glassy-input textarea::placeholder {
      color: #6b7a8a !important;
    }

  .glassy-input .v-input__prepend-inner .v-icon {
    color: #4a5568;
    transition: color 0.3s ease;
  }

  .glassy-input.v-text-field--outlined .v-input__slot fieldset {
    border-color: rgba(255, 255, 255, 0.15);
    border-width: 1px;
  }

  .glassy-input.v-text-field--outlined .v-input__slot:hover fieldset {
    border-color: rgba(255, 255, 255, 0.30);
  }

  .glassy-input.v-text-field--outlined .v-input__slot:focus-within fieldset {
    border-color: #74a533;
  }

  .dnt-modern-input > > > .v-input__slot {
    border-radius: 12px !important;
  }

  /* --- Summary Cards --- */
  .dnt-summary-item {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .dnt-summary-icon {
    font-size: 40px;
    color: #74a533 !important;
    filter: drop-shadow(0 2px 4px rgba(116, 165, 51, 0.1));
  }

  .dnt-summary-label {
    font-size: 12px;
    opacity: 0.7;
    margin-bottom: 4px;
    color: #4a5568;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .dnt-summary-value {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    color: #1e2a3a;
  }

  /* --- Status Card --- */
  .glassy-status-card {
    border-radius: 16px !important;
    border: 1px solid rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }

  .dnt-status-item {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .dnt-status-icon {
    font-size: 40px;
    color: #4a5568 !important;
  }

  .dnt-status-label {
    font-size: 12px;
    opacity: 0.7;
    margin-bottom: 4px;
    color: #4a5568;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .dnt-status-value {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    color: #1e2a3a;
  }

  /* --- Glassy Buttons - More Transparent --- */
  .glassy-btn-error {
    background: rgba(244, 67, 54, 0.60) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: white !important;
    border-radius: 60px;
    padding: 10px 28px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    transition: all 0.25s ease;
    box-shadow: 0 6px 20px rgba(244, 67, 54, 0.10);
  }

    .glassy-btn-error:hover {
      background: rgba(244, 67, 54, 0.80) !important;
      transform: translateY(-3px) scale(1.02);
      box-shadow: 0 10px 30px rgba(244, 67, 54, 0.20);
    }

    .glassy-btn-error:active {
      transform: translateY(0) scale(0.98);
    }

  .glassy-btn-secondary {
    background: rgba(108, 117, 125, 0.60) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: white !important;
    border-radius: 60px;
    padding: 10px 28px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    transition: all 0.25s ease;
    box-shadow: 0 6px 20px rgba(108, 117, 125, 0.10);
  }

    .glassy-btn-secondary:hover {
      background: rgba(108, 117, 125, 0.80) !important;
      transform: translateY(-3px) scale(1.02);
      box-shadow: 0 10px 30px rgba(108, 117, 125, 0.20);
    }

    .glassy-btn-secondary:active {
      transform: translateY(0) scale(0.98);
    }

  .dnt-action-btn {
    border-radius: 60px !important;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .dnt-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* --- Glassy Link --- */
  .glassy-link {
    color: #1e2a3a !important;
    text-decoration: none;
    font-weight: 500;
    padding: 4px 12px;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.10);
    transition: all 0.2s ease;
  }

    .glassy-link:hover {
      color: #74a533 !important;
      background: rgba(255, 255, 255, 0.30);
      text-decoration: none;
    }

  .dnt-booking-link {
    margin-left: 8px;
  }

  /* --- Earthwerk Font --- */
  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    color: #1e2a3a;
    line-height: 1.3;
    letter-spacing: 0.5px;
  }

  /* --- Status Color Overrides - More Transparent --- */
  .glassy-status-card.v-card.success {
    background: rgba(76, 175, 80, 0.15) !important;
    border-color: rgba(76, 175, 80, 0.30);
  }

  .glassy-status-card.v-card.warning {
    background: rgba(255, 193, 7, 0.15) !important;
    border-color: rgba(255, 193, 7, 0.30);
  }

  .glassy-status-card.v-card.error {
    background: rgba(244, 67, 54, 0.15) !important;
    border-color: rgba(244, 67, 54, 0.30);
  }

  .glassy-status-card.v-card.grey {
    background: rgba(158, 158, 158, 0.15) !important;
    border-color: rgba(158, 158, 158, 0.30);
  }

  /* --- Responsive --- */
  @media (max-width: 960px) {
    .dnt-container {
      padding: 16px;
    }

    .dnt-title {
      font-size: 24px;
    }

    .dnt-card {
      padding: 16px;
    }

    .dnt-summary-item,
    .dnt-status-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .dnt-summary-icon,
    .dnt-status-icon {
      font-size: 32px;
    }

    .dnt-summary-value,
    .dnt-status-value {
      font-size: 18px;
    }

    .glassy-btn-error,
    .glassy-btn-secondary {
      padding: 8px 20px;
      font-size: 14px;
    }
  }

  @media (max-width: 600px) {
    .dnt-container {
      padding: 10px;
    }

    .dnt-card {
      padding: 12px;
      border-radius: 16px !important;
    }

    .dnt-title {
      font-size: 20px;
    }

    .dnt-section-title {
      font-size: 16px;
    }

    .dnt-summary-icon,
    .dnt-status-icon {
      font-size: 28px;
    }

    .dnt-summary-value,
    .dnt-status-value {
      font-size: 16px;
    }

    .dnt-summary-label,
    .dnt-status-label {
      font-size: 11px;
    }

    .glassy-btn-error,
    .glassy-btn-secondary {
      padding: 8px 16px;
      font-size: 13px;
      width: 100%;
      justify-content: center;
    }

    .dnt-actions {
      flex-direction: column;
    }

    .dnt-action-btn {
      width: 100%;
      margin-right: 0;
    }

    .glassy-card {
      padding: 16px !important;
    }

    .glassy-sub-card {
      padding: 8px !important;
    }
  }

  /* --- Global Vuetify overrides --- */
  .glassy-app ::v-deep .v-application--wrap {
    background: transparent !important;
  }

  .glassy-app ::v-deep .glassy-input.v-text-field--outlined.v-input--is-focused .v-label {
    color: #74a533 !important;
  }

  .glassy-app ::v-deep .v-input--is-focused .v-input__slot {
    background: rgba(255, 255, 255, 0.30) !important;
  }

  .glassy-app ::v-deep .v-card__text {
    color: #1e2a3a !important;
  }

  .glassy-app ::v-deep .v-input__append-outer .v-icon {
    color: #4a5568 !important;
  }
</style>
